import { ReactNode } from "react";
import { getClassName } from "@pairtreefamily/utils";
import Button from "./button";

export type ContentGridProps = {
  children: ReactNode;
  onLoadMore?: () => Promise<void>;
  hideLoadMore?: boolean;
};

export function ContentGrid(props: ContentGridProps) {
  const containerClass = getClassName("flex flex-col", "items-center");

  const gridClass = getClassName(
    "grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4",
    "gap-8",
  );

  const buttonClass = getClassName(
    "rounded-full",
    "border-green border-2",
    "max-w-sm",
    "py-2 px-8",
    "mt-11",
  );

  return (
    <div className={containerClass}>
      <div className={gridClass}>{props.children}</div>
      {!props.hideLoadMore && (
        <Button
          className={buttonClass}
          onClick={props.onLoadMore}
          style="secondary"
          color="green"
        >
          Load More
        </Button>
      )}
    </div>
  );
}

export default ContentGrid;
